(function () {
    'use strict';
    /*
     * Copyright (c) 2014-15 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .directive('ihhItem', ihhItem);

    ihhItem.$inject = ['$compile'];

    /**
     * A directive for a single item in an item chooser.
     * @ngdoc directive
     * @memberOf ihh-common-web.ihh-item-chooser
     * @name ihh-item
     * @param {ihh-common-web.ihh-item-chooser.Config} config The configuration object.
     * @param {Object} item the single item in the chooser
     */
    function ihhItem($compile) {
        return {
            require: '^ihhItemChooser',
            restrict: 'E',
            link: function(scope, element, attrs, ctrl, transclude) {

                transclude(scope, function(clone, scope) {
                    element.empty();
                    element.append(clone);
                    $compile(clone)(scope);
                });
            },
            scope: {
                config: '=',
                item: '='
            }
        };
    }
})();